module.exports = __webpack_public_path__ + "static/media/boardfolio-steps-en.bd257dc9.png";